import { createReducer, on } from "@ngrx/store";
import { SetSelectedCourse, SetPanelState, UpdatePanelState, SetAllowPopUp, GetLearningPlan, GetLearningPlanSuccess, GetLearningPlanError, AssignSkillsCheckContentError, AssignSkillsCheckContent, SetActiveActivity, GetLearnerLearningPlan, GetLearnerLearningPlanSuccess, GetLearnerLearningPlanError, ResetLearningPlan, GenerateLearningPlan, EditLearningPlan, EditLearningPlanSuccess, EditLearningPlanError, ResetEditLearningPlan, GetManualLearningPlan, GetManualLearningPlanSuccess, GetManualLearningPlanError, SaveManualLearningPlan, SaveManualLearningPlanSuccess, SaveManualLearningPlanError, UpdateWrittenAssignment, GetCategoryOnCurrentLevelChangeSuccess } from "./learning-plan.actions";
import { initialLearningPlanState, LearningPlanState } from "./learning-plan.state";
import { getPanelState } from "./learning-plan.utils";

export const LearningPlanReducers = createReducer(
	initialLearningPlanState,

	on(SetPanelState, (state, action): LearningPlanState => {
			return {
					...state,
					panelState: getPanelState(state, action)
			}
	}),
	on(UpdatePanelState, (state, action): LearningPlanState => {
			return {
					...state,
					panelState: state.panelState.map((panel => 
						(panel.topicId === action.topicId) ? {...panel, expanded: !panel.expanded} : panel))
			}
	}),
	on(SetSelectedCourse, (state, action): LearningPlanState => {
			return { 
					...state,
					panelState: (action.courseId == state.course) ? state.panelState : [],
					course: action.courseId
					
			}
	}),
	on(SetAllowPopUp, (state, action): LearningPlanState => {
		return {
			...state,
			allowPopUp: action.allowPopUp
		}
	}),
	on(GetLearningPlan, (state): LearningPlanState => {
		return {
			...state,
			result: [],
			loader: true,
			error: null,
			reminders: []
		}
	}),
	on(GetLearningPlanSuccess, (state, action): LearningPlanState => {

		const reminders = action.result.filter(x => x.reminder === true);

		return {
			...state,
			result: action.result,
			allowPopUp: (reminders.length > 0),
			loader: false,
			reminders: reminders
		}
	}),
	on(GetLearningPlanError, (state, action): LearningPlanState => {
		return {
			...state,
			loader: false,
			error: action.error
		}
	}),
	on(GetManualLearningPlan, (state): LearningPlanState => {
		return {
			...state,
			manualLearningPlan: [],
			error: null,
		}
	}),
	on(GetManualLearningPlanSuccess, (state, action): LearningPlanState => {
		return {
			...state,
			manualLearningPlan: action.result,
		}
	}),
	on(GetManualLearningPlanError, (state, action): LearningPlanState => {
		return {
			...state,
			error: action.error
		}
	}),
	on(SaveManualLearningPlan, (state): LearningPlanState => {
		return {
			...state,
			manualLearningPlan: [],
			manualLearningPlanLoader: true,
			error: null,
			isManualLearningPlanSuccess: false
		}
	}),
	on(SaveManualLearningPlanSuccess, (state, action): LearningPlanState => {
		return {
			...state,
			isManualLearningPlanSuccess: action.result,
			manualLearningPlanLoader: false,
		}
	}),
	on(SaveManualLearningPlanError, (state, action): LearningPlanState => {
		return {
			...state,
			manualLearningPlanLoader: false,
			error: action.error,
			isManualLearningPlanSuccess: false
		}
	}),
	on(AssignSkillsCheckContent, (state): LearningPlanState => {
		return {
			...state,
			loader: true,
			error: null
		}
	}),
	on(AssignSkillsCheckContentError, (state, action): LearningPlanState => {
		return {
			...state,
			loader: false,
			error: action.error
		}
	}),
	on(SetActiveActivity, (state, action): LearningPlanState => {
		return {
			...state,
			active: action.activity
		}
	}),
	on(GetLearnerLearningPlan, (state, action): LearningPlanState => {
		return {
			...state,
			result: [],
			loader: true,
			error: null,
			reminders: []
		}
	}),
	on(GetLearnerLearningPlanSuccess, (state, action): LearningPlanState => {
		return {
			...state,
			result: action.result,
			loader: false,
		}
	}),
	on(GetLearnerLearningPlanError, (state, action): LearningPlanState => {
		return {
			...state,
			loader: false,
			error: action.error
		}
	}),
	on(ResetLearningPlan, (_): LearningPlanState => {
		return initialLearningPlanState;
	}),
	on(GenerateLearningPlan, (state): LearningPlanState => {
		return {
			...state,
			editLearningPlanError: null,
			editLearningPlanLoader: true,
			editLearningPlanResult: null
		}
	}),
	on(EditLearningPlan, (state): LearningPlanState => {
		return {
			...state,
			editLearningPlanError: null,
			editLearningPlanLoader: true,
			editLearningPlanResult: null
		}
	}),
	on(EditLearningPlanSuccess, (state, action): LearningPlanState => {
		return {
			...state,
			editLearningPlanLoader: false,
			editLearningPlanResult: action.result
		}
	}),
	on(EditLearningPlanError, (state, action): LearningPlanState => {
		return {
			...state,
			editLearningPlanLoader: false,
			editLearningPlanError: action.error
		}
	}),
	on(ResetEditLearningPlan, (state): LearningPlanState => {
		return {
			...state,
			editLearningPlanLoader: false,
			editLearningPlanError: null,
			editLearningPlanResult: null
		}
	}),
	on(UpdateWrittenAssignment, (state, action): LearningPlanState => {		
		let panel = state.panelState.find(item => item.topicId === action.topicId);
		let writtenAssignments = panel.writtenAssignments.map(
				(item => (item.name === action.writtenAssignment) ? {...item, toBeAssigned: !item.toBeAssigned}: item));

			return {
					...state,
					panelState: state.panelState.map((panel => 
						(panel.topicId === action.topicId) ? {...panel, writtenAssignments: writtenAssignments} : panel))
			}
	}),
	on(GetCategoryOnCurrentLevelChangeSuccess, (state, action): LearningPlanState => {		
		return {
			...state,
			panelState: state.panelState.map((panel => 
			(panel.topicId === action.result.topicId) ? 
				{...panel, 
					writtenAssignments: action.result.writtenAssignments,
					learnerLearningObjectId: action.result.learnerLearningObjectId,
					skillsCheckObjectId: action.result.skillsCheckObjectId,
					skillsCheckPath: action.result.skillsCheckPath,
					isSkillsCheckTutorEnforced: action.result.isSkillsCheckTutorEnforced,
					newCurrentLevel: action.result.level
				} : panel))
		}
	}),
)